import { Yield } from '../../abacus/interfaces/yield.interface'

export const approachYields: Yield[] = [
  {
    label: 'Name',
    property: 'name'
  },
  {
    label: 'Description',
    property: 'description'
  }
]
